import { FilterBuilder } from '../Types';

const multiUnitListingsBuilder: FilterBuilder = (params, context) => {
  // filter out all multi unit listings from search results.
  return context?.withoutMultiUnits ? 'isMultiUnit:false' : '';
};

export { multiUnitListingsBuilder };
